<template>
  <div class="inspection-container" v-loading="loading">
    <component :is="views" @gotoPage="gotoPage" :inspectionData="inspectionData" />
  </div>
</template>

<script setup name="InspectionQuestionManager">
import { cloneDeep } from "lodash";
import { ElMessage, ElMessageBox } from "element-plus";
import { computed, provide, toRaw } from "vue";
import { $emit, $on } from "vue-happy-bus";
import index from "./pages/index.vue";
import area from "./pages/area.vue";
import login from "./pages/login.vue";
import register from "./pages/register.vue";
import center from "./pages/center.vue";
import form from "./pages/form.vue";
import preview from "./pages/preview.vue";

const getGrandchildValue = inject("getGrandchildValue");

const props = defineProps({
  currentQa: {
    // 当前题目信息对象
    required: true,
    type: Object,
  },
});

const route = useRoute();
const router = useRouter();
const isDev = ref(import.meta.env.DEV);
const { proxy } = getCurrentInstance();
const { id } = route.query;
const loading = ref(false);
const checkRuleRef = ref({});
const initialAnswerRef = ref([]);

provide("checkRule", checkRuleRef);
provide("initialAnswer", initialAnswerRef);
const init = async () => {
  loading.value = true;

  try {
    const solution = props.currentQa.solution && JSON.parse(props.currentQa.solution);
    const checkRule = props.currentQa.checkRule && JSON.parse(props.currentQa.checkRule);
    const initialAnswer = props.currentQa.initialAnswer && JSON.parse(props.currentQa.initialAnswer);

    if (solution) {
      inspectionDataUpdate(solution);
    } else {
      inspectionData.value.reportData.reportYear = checkRule && checkRule.reportYear;
    }

    getGrandchildValue.value.getData = () => {
      return {
        solution: JSON.stringify(inspectionData.value),
      };
    };

    if (checkRule) {
      checkRuleRef.value = checkRule;
    }

    if (initialAnswer instanceof Array && initialAnswer.length > 0) {
      initialAnswerRef.value = initialAnswer;
    }

    console.log("获取数据", {
      solution,
      checkRule,
      initialAnswer,
    });
  } finally {
    loading.value = false;
  }
};

// 页面
const pages = {
  index,
  area,
  login,
  register,
  center,
  form,
  preview,
};

const gotoPage = (page) => {
  views.value = pages[page];
};

const views = shallowRef();

$on("gotoPage", (page) => {
  gotoPage(page);
});

// 重新做题
getGrandchildValue.value.getResetData = () => {
  inspectionDataInit();

  return {
    solution: "",
  };
};

$on("inspectionUpdate", (inspectionData) => {
  inspectionDataUpdate(inspectionData);
});

// 提交
$on("inspectionSubmit", (inspectionData) => {
  console.log("提交数据", inspectionData);

  getGrandchildValue.value.getData = () => {
    return {
      solution: JSON.stringify(inspectionData),
    };
  };

  getGrandchildValue.value.fillFinish = () => {
    return true;
  };

  inspectionDataUpdate(inspectionData);

  $emit("exeSaveQa");
});

// 保存成功回调
$on("saveQaSuccess", (res) => {
  ElMessage.success("提交成功");
});

onMounted(() => {
  init();
});

const inspectionDataJson = {
  reportData: {
    reportYear: null,
    lastModifyDate: null,
    publicStatus: null,
    publicDate: null,
  },
  formDataMain: {
    license: {
      isShow: 0,
      name: "充装单位许可证",
      data: [],
    },
    base: {
      isShow: 1,
      name: "企业基本信息",
      data: {
        empnumdis: "2",
        womempnumdis: "2",
        isdwdb: "2",
        ishasweb: "2",
        isgdgqzr: "2",
        istzinfo: "2",
      },
    },
    share: {
      isShow: 1,
      name: "股东及出资信息",
      data: [],
    },
    site: {
      isShow: 0,
      name: "网站或网店信息",
      data: [],
    },
    change: {
      isShow: 0,
      name: "股权变更信息",
      data: [],
    },
    invest: {
      isShow: 0,
      name: "对外投资信息",
      data: [],
    },
    assert: {
      isShow: 1,
      name: "资产状况信息",
      data: {
        assgrodis: "2",
        totequdis: "2",
        liagrodis: "2",
        vendincdis: "2",
        maibusincdis: "2",
        progrodis: "2",
        netincdis: "2",
        ratgrodis: "2",
      },
    },
    guaranty‌: {
      isShow: 0,
      name: "对外担保信息",
      data: [],
    },
    party: {
      isShow: 1,
      name: "党建信息",
      data: {
        resparmsign: "2",
        resparsecsign: "2",
      },
    },
    social: {
      isShow: 1,
      name: "社保信息",
      data: {
        totalwagesdis: "2",
        totalpaymentdis: "2",
        unpaidsocialinsdis: "2",
      },
    },
  },
  formDataRegister: {},
  formDataLogin: {},
};

const inspectionData = ref({});

const inspectionDataInit = () => {
  inspectionData.value = cloneDeep(inspectionDataJson);
};

const inspectionDataUpdate = (data) => {
  inspectionData.value = cloneDeep(data);
};

inspectionDataInit();

gotoPage("index");
</script>

<style scoped lang="scss">
.inspection-container {
  width: 100%;
  height: 100%;
  font-size: 14px;
  line-height: 1.5;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-track {
    background: #efefef;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track-piece {
    background: none;
  }
}
</style>
